import { useState } from "react";
import { AdvancedMarker } from "@vis.gl/react-google-maps";
import { Box, Tooltip } from "@mui/material";
import { getAddressDetails } from "features/maps/util/getAddressDetails";
import Dot from "features/maps/Dot";

type PlaceMarkerProps = {
  place: google.maps.places.Place;
  selected?: boolean;
  onSelect?: (place: google.maps.places.Place) => void;
};

const PlaceMarker: React.FC<PlaceMarkerProps> = (props) => {
  const { place, selected, onSelect } = props;

  const [hovered, setHovered] = useState(false);

  const address = getAddressDetails(place);

  return (
    <AdvancedMarker
      position={place.location}
      onClick={() => {
        setHovered(false);
        onSelect?.(place);
      }}
      onMouseEnter={() => {
        setHovered(true);
      }}
      onMouseLeave={() => setHovered(false)}
    >
      {selected ? null : ( // show default marker (pin) for selected place
        <Tooltip
          title={
            <>
              {place.displayName !== address.address && (
                <strong>
                  {place.displayName}
                  <br />
                </strong>
              )}
              {address.address}
              <br />
              {[address.postalCode, address.city].filter(Boolean).join(" ")}
            </>
          }
          placement="top"
          arrow
          open={hovered}
        >
          <Box>
            <Dot color="#e1412f" size="small" />
          </Box>
        </Tooltip>
      )}
    </AdvancedMarker>
  );
};

export default PlaceMarker;
